// Minimum render width we promise the yard canvas when any drawer is open.
// Below this, the right container-details panel auto-collapses (see
// useCanvasWidthGuard). In stack mode the right drawer is ~648px (3 cols × 200
// + 48 padding) — so viewports below ~1528px would trigger the collapse. In
// bay/row mode the right drawer floors at `viewport × 0.5` (see
// MULTI_COLUMN_DRAWER_VIEWPORT_FRACTION in use-container-details-drawer-width.ts),
// so it scales with the viewport and the trigger boundary moves accordingly.
export const MIN_CANVAS_WIDTH_PX = 480

export interface CanvasWidthInputs {
  viewportWidth: number
  leftDrawerOpen: boolean
  rightDrawerOpen: boolean
  leftDrawerWidth: number
  rightDrawerWidth: number
  minCanvasWidth: number
}

export const shouldAutoCollapseRightPanel = ({
  viewportWidth,
  leftDrawerOpen,
  rightDrawerOpen,
  leftDrawerWidth,
  rightDrawerWidth,
  minCanvasWidth,
}: CanvasWidthInputs): boolean => {
  if (!leftDrawerOpen || !rightDrawerOpen) return false
  if (viewportWidth <= 0 || leftDrawerWidth < 0 || rightDrawerWidth < 0) return false
  const canvas = viewportWidth - leftDrawerWidth - rightDrawerWidth
  return canvas < minCanvasWidth
}
